import React from 'react';
import PropTypes from 'prop-types';

import TabItem from './OnlineMarketsTabsHeaderItem';

const OnlineMarketsTabsHeader = ({ selectedTab, tabs, actions, marketOrderNotifikation }) => {
    const handleClickKill = scope => {
        actions.killOrders(scope);
    };

    const showProductInfo = view => {
        const { args } = view;
        actions.storeMarketLogArgs(args);
        actions.setSelectedView(view);
        localStorage.setItem('marketLogArgs', JSON.stringify(args));
        actions.getMarketLog(args); // initiates search on open OnlineMarkets view
    };

    const handleClickTab = newTabIndex => {
        showProductInfo(tabs[newTabIndex]);
    };

    return (
        <div className="OnlineMarketsTabsHeaderWrapper">
            <div className="OnlineMarketsTabsWrapper">
                {tabs.map((tab, index) => {
                    const notification =
                        marketOrderNotifikation !== null &&
                        tab.args.include.products.find(p => marketOrderNotifikation.product_id === p)
                            ? marketOrderNotifikation
                            : null;

                    return (
                        <TabItem
                            key={`onlinemarketstapheader_${tab.id}`}
                            tabName={tab.name}
                            selectedTab={selectedTab}
                            isSelectedTab={selectedTab === index}
                            index={index}
                            handleClickTab={handleClickTab}
                            orderNotification={notification}
                        />
                    );
                })}
            </div>
            <div className="OnlineMarketsKillActionsWrapper">
                <div className="OnlineMarketsHeaderItem KillAction" onClick={() => handleClickKill('BUY')}>
                    PULL BIDS
                </div>
                <div className="OnlineMarketsHeaderItem KillAction" onClick={() => handleClickKill('SELL')}>
                    PULL OFFERS
                </div>
                <div className="OnlineMarketsHeaderItem KillAction" onClick={() => handleClickKill('ALL')}>
                    PULL ALL
                </div>
            </div>
        </div>
    );
};

OnlineMarketsTabsHeader.propTypes = {
    selectedTab: PropTypes.number,
    tabs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    marketOrderNotifikation: PropTypes.shape({}),
    actions: PropTypes.shape({
        killOrders: PropTypes.func.isRequired,
        storeMarketLogArgs: PropTypes.func.isRequired,
        setSelectedView: PropTypes.func.isRequired,
        getMarketLog: PropTypes.func.isRequired,
    }).isRequired,
};

OnlineMarketsTabsHeader.defaultProps = {
    selectedTab: null,
    marketOrderNotifikation: null,
};

export { OnlineMarketsTabsHeader };



// WEBPACK FOOTER //
// ./source/components/OnlineMarketsTabsHeader.js